import { render, staticRenderFns } from "./addChannel.vue?vue&type=template&id=1b6b9ec8&scoped=true&"
import script from "./addChannel.vue?vue&type=script&lang=js&"
export * from "./addChannel.vue?vue&type=script&lang=js&"
import style0 from "./addChannel.vue?vue&type=style&index=0&id=1b6b9ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b9ec8",
  null
  
)

export default component.exports